module.exports = __webpack_public_path__ + "img/total.a016d90d.png";